export default "__VITE_ASSET__1bPSUB19__"